import axios from 'axios';
import type { PartnerProposalFile } from '@/components/Applications/EnterpriseLBAForm/type';
import type { QueryParamsInterface, SignDeveloperAssetPayload, SignedApplicationAssetResponse } from '../../types/Shared';
import { baseUrl, HttpMethods } from '../base';
import type { IPartnerProposalsDashboard } from './types';

interface PostPartnerProposalService {
  formData: any;
}

export async function postPartnerProposal({ data }: { data: PostPartnerProposalService }) {
  const res = await axios({
    method: HttpMethods.POST,
    url: `${baseUrl.SHERPA}/partner_proposals`,
    data,
  });
  return res.data;
}

interface IGetPartnerProposalsService {
  params?: QueryParamsInterface;
}

export async function getPartnerProposals({ params }: IGetPartnerProposalsService) {
  const res = await axios({
    method: HttpMethods.GET,
    url: `${baseUrl.SHERPA}/partner_proposals`,
    params,
  });
  return res.data;
}

export async function getPartnerProposal({ applicationId }: { applicationId: number }) {
  const res = await axios({
    method: HttpMethods.GET,
    url: `${baseUrl.SHERPA}/partner_proposals/${applicationId}`,
  });
  return res.data;
}

export async function patchPartnerProposal({ applicationId, data }: { applicationId: number; data: { status?: string; formData?: any } }) {
  const res = await axios({
    method: HttpMethods.PATCH,
    url: `${baseUrl.SHERPA}/partner_proposals/${applicationId}`,
    data,
  });
  return res.data;
}

export async function archivePartnerProposal(proposalId: number) {
  const res = await axios({
    method: HttpMethods.PATCH,
    url: `${baseUrl.SHERPA}/partner_proposals/${proposalId}/archive`,
  });
  return res.data;
}

export async function archiveClientApplication(applicationId: number) {
  const res = await axios({
    method: HttpMethods.PATCH,
    url: `${baseUrl.SHERPA}/partner_proposals/${applicationId}/archive`,
  });
  return res.data;
}

export interface PPSignedAssetResponse extends SignedApplicationAssetResponse {}

export const signDeveloperAsset = async ({ field, ...rest }: SignDeveloperAssetPayload) => {
  const res = await axios.request<PPSignedAssetResponse>({
    url: `${baseUrl.SHERPA}/assets/partner_proposal/sign`,
    method: 'POST',
    data: rest,
  });
  return { ...res.data, field };
};

export async function addPartnerProposalFiles({ applicationId, files }: { applicationId: number; files: PartnerProposalFile[] }) {
  const res = await axios({
    method: HttpMethods.PUT,
    url: `${baseUrl.SHERPA}/partner_proposals/${applicationId}/file`,
    data: { files },
  });
  return res.data;
}

export async function deletePartnerProposalFiles({ applicationId, key }: { applicationId: number; key: string }) {
  const res = await axios({
    method: HttpMethods.DELETE,
    url: `${baseUrl.SHERPA}/partner_proposals/${applicationId}/file`,
    data: { key },
  });
  return res.data;
}

export async function getPartnerProposalsDashboard() {
  const res = await axios.request<IPartnerProposalsDashboard>({
    method: HttpMethods.GET,
    url: `${baseUrl.SHERPA}/analytics/rover`,
  });
  return res.data;
}
